<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <card>
            <button class="btn btn-primary" @click="editProduct">
              <i class="fas fa-edit icon-primary"></i>
            </button>
            <!-- <h4  style=" text-align:center" slot="header" class="card-title">{{ product.name }}</h4> -->
            <form>
              <div class="col-md-4" style="margin: auto">
                <img :src="product.imagee" :alt="product.name" class="card-img mb-5"
                  style="width: 100%; border-radius: 15px" />
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="detailsLabel">الاسم</label>
                  <input type="text" v-model="product.name" class="detailsInput" :disabled="true" />
                </div>
              </div>

              <div class="row">
                <!-- <div class="col-md-6">
                  <label class="detailsLabel">الطول بالعربية</label>
                  <input
                    type="text"
                    v-model="product.height"
                    class="detailsInput"
                    :disabled="true"
                  />
                </div> -->
                <div class="col-md-6">
                  <label class="detailsLabel">الطول</label>
                  <input type="text" :value="product.height + ' ' + $t('cm')" class="detailsInput" :disabled="true" />
                </div>
              </div>

              <div class="row">
                <!-- <div class="col-md-6">
                  <label class="detailsLabel">العرض بالعربية</label>
                  <input
                    type="text"
                    v-model="product.depth"
                    class="detailsInput"
                    :disabled="true"
                  />
                </div> -->
                <div class="col-md-6">
                  <label class="detailsLabel">العرض</label>
                  <input type="text" :value="product.depth + ' ' + $t('cm')" :disabled="true" class="detailsInput" />
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-md-6">
                  <label class="detailsLabel">السعر بالعربية</label>
                  <input
                    type="text"
                    v-model="product.multilingualData.ar.price"
                    class="detailsInput"
                    :disabled="true"
                  />
                </div>
                <div class="col-md-6">
                  <label class="detailsLabel">السعر بالإنجليزية</label>
                  <input
                    type="number"
                    v-model="product.multilingualData.en.price"
                    class="detailsInput"
                    :disabled="true"
                  />
                </div>
              </div> -->

              <!-- <div class="row">
                <div class="col-md-6">
                  <label class="detailsLabel">المادة الخام بالعربية</label>
                  <input
                    type="text"
                    v-model="product.multilingualData.ar.material"
                    class="detailsInput"
                    :disabled="true"
                  />
                </div>
                <div class="col-md-6">
                  <label class="detailsLabel">المادة الخام بالإنجليزية</label>
                  <input
                    type="text"
                    v-model="product.multilingualData.en.material"
                    class="detailsInput"
                    :disabled="true"
                  />
                </div>
              </div> -->

              <div class="row">
                <div class="col-md-6">
                  <label class="detailsLabel">الستايل بالعربية</label>
                  <input type="text" v-model="product.multilingualData.ar.style" class="detailsInput"
                    :disabled="true" />
                </div>
                <div class="col-md-6">
                  <label class="detailsLabel">الستايل بالإنجليزية</label>
                  <input type="text" v-model="product.multilingualData.en.style" class="detailsInput"
                    :disabled="true" />
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="detailsLabel">الوصف بالعربية</label>
                    <textarea rows="2" class="detailsInput" v-model="product.multilingualData.ar.description"
                      :disabled="true">
                    </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="detailsLabel">الوصف بالإنجليزية</label>
                    <textarea rows="2" class="detailsInput" v-model="product.multilingualData.en.description"
                      :disabled="true">
                    </textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="detailsLabel">القسم</label>
                  <input type="text" v-model="categoryName" :disabled="true" class="detailsInput" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <table class="table materialsTable">
                    <thead>
                      <tr>
                        <th style="text-align: center !important;">المادة بالعربية</th>
                        <th style="text-align: center !important;">المادة بالإنجليزية</th>
                        <th style="text-align: center !important;">السعر</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="materialPrice in product.ProductMaterialPrices" :key="materialPrice.Material.id">
                        <td>{{ materialPrice.Material.name_ar }}</td>
                        <td>{{ materialPrice.Material.name }}</td>
                        <td>{{ materialPrice.price }}&nbsp; {{ $t("EGP") }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="detailsLabel" style="color: rgb(97, 97, 97);">*{{ product.multilingualData.ar.execute
                    }}*</label>
                </div>
              </div>
              <div class="clearfix"></div>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "src/Dashboard/SharedComponents/Card.vue";
import Axios from "../../../Axios";

export default {
  components: {
    Card,
  },
  data() {
    return {
      product: {
        name: "",
        name_ar: "",
        description: "",
        height: "",
        height_ar: "",
        depth: "",
        depth_ar: "",
        material: "",
        material_ar: "",
        style: "",
        imagee: ""
      },
      categoryName: "",
    };
  },
  methods: {
    editProduct() {
      const id = this.$route.params.id;
      this.$router.push("/admin/edit-product/" + id);
    },
    fetchData() {
      const id = this.$route.params.id;
      Axios
        .get("/dashboard/product/" + id)
        .then((response) => {
          this.product = response.data.data;
          if (this.product.imagee && this.product.imagee.type === 'Buffer' && Array.isArray(this.product.imagee.data)) {
            const buffer = Buffer.from(this.product.imagee.data);
            const base64Image = buffer.toString('base64');
            this.product.imagee = `data:image/jpeg;base64,${base64Image}`; // Adjust MIME type if needed
          }

          Axios
            .get(
              `/dashboard/category/${this.product.categoryId}`
            )
            .then((categoryResponse) => {
              // console.log(
              //   categoryResponse.data.data.categoryData.name_ar,
              //   "fdfdfd"
              // );
              // this.categoryName = categoryResponse.data.data.category.name;
              this.categoryName =
                categoryResponse.data.data.categoryData.name_ar;
            })
            .catch((error) => {
              console.error(error);
            });
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

  mounted() {
    this.fetchData();
  },
};
</script>
<style>
.detailsInput {
  width: 100%;
  padding: 10px;
  padding-top: 5px;
  font-size: 14px;
  border: none;
  background-color: rgba(255, 255, 255, 0.626);
}

.detailsLabel {
  font-weight: 800 !important;
  font-size: 16px !important;
}

.materialsTable {
  width: 100%;
  border-collapse: collapse;
}

.materialsTable th,
.materialsTable td {
  text-align: center;
  padding: 8px;
  border-bottom: none;
}

.materialsTable th {
  background-color: #e9e8e8;
}

.materialsTable td {
  background-color: rgba(255, 255, 255, 0.572);
}
</style>